// extracted by mini-css-extract-plugin
module.exports = {"defaultIconStyle":"az_so","fontSizeInherit":"az_to","fontSizeSmall":"az_uo","fontSizeLarge":"az_vo"};